import { IFormat } from '../../../../../store/admin/roundFormats/store';

export const filterOptions = (availableOptions: IFormat[], filterContest: boolean): IFormat[] =>
  availableOptions
    ? availableOptions.filter(formatOption => filterContest === formatOption.isContest)
    : [];
